/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable no-eval */
import _ from 'lodash';

import {
  getDataMemberPath,
  getParentRelationshipKey,
  getRelationShipKey,
  toArray,
} from './form-manager.utils';
import {
  columnValueNotUniqueImpl,
  columnValueWithFilterImpl,
  convertArrayToDoublePipeDelimitedStringImpl,
  currentRecordIdImpl,
  evaluateDynamicFormulaImpl,
  getCurrentRowValueImpl,
  getDateAddBusinessDaysImpl,
  getLicensedModuleImpl,
  getNumberingSchemeImpl,
  maxImpl,
  maxWithFilterImpl,
  minImpl,
  minimumValueImpl,
  minWithFilterImpl,
  rowCountImpl,
  rowCountWithFilterImpl,
  rowIndexImpl,
  sumImpl,
  sumWithFilterImpl,
} from './functionsImp.utils';
import _ss from './pilgrim.expression.formulas.utils';
import { isTrue } from '../../utils/commonUtils';
import { ENTITY_DATA_PREFIX } from '../constants/form-manager.constants';

const ssFunctions = {
  columnValueNotUniqueImpl,
  columnValueWithFilterImpl,
  convertArrayToDoublePipeDelimitedStringImpl,
  currentRecordIdImpl,
  evaluateDynamicFormulaImpl,
  getCurrentRowValueImpl,
  getNumberingSchemeImpl,
  getLicensedModuleImpl,
  getDateAddBusinessDaysImpl,
  maxImpl,
  maxWithFilterImpl,
  minImpl,
  minimumValueImpl,
  minWithFilterImpl,
  rowCountImpl,
  rowCountWithFilterImpl,
  rowIndexImpl,
  sumImpl,
  sumWithFilterImpl,
};

export const evalSSEexpression = (ssStr, ssContext) => {
  if (typeof ssStr !== 'string') {
    return ssStr;
  }

  const { data, entityType, gridArrIndex, entityDefinition } = ssContext;

  if (data === undefined || entityType === undefined) {
    console.log('data and entityType should be in the scope - its used for evaluation');
    return ssStr;
  }

  let preprocessed = preprocessSSEvaluation(ssStr);
  preprocessed = preprocessRuleContext(preprocessed, ssContext);
  preprocessed = patchClientManagerLookup(preprocessed);
  preprocessed = resolveData(data, entityType, gridArrIndex, entityDefinition, preprocessed); // don't replace it with regexp - we may need resolve data inside later

  return evaluate(preprocessed, { ...ssContext, ...ssFunctions });
};

// TODO: deprecated, use evalSSEexpression()
/* Currently Used for SSHyperlink Expressions */
export const evalExpression = (expression, ssContext) => {
  if (!isExpression(expression)) {
    return expression;
  }

  const {
    data,
    entityType,
    gridArrIndex,
    controlIsInTable,
    contextDataMember,
    entityDefinition,
    isHyperlinkUrl,
  } = ssContext;

  const resolvedDataExpression = resolveData(
    data,
    entityType,
    gridArrIndex,
    entityDefinition,
    expression
  );
  const nothingWasResolved = resolvedDataExpression.localeCompare(expression) === 0;

  let dataContext;

  if (nothingWasResolved && controlIsInTable && !expression.startsWith('data.')) {
    dataContext = _.get(
      data,
      getDataMemberPath({
        entityType,
        dataMember: contextDataMember,
        gridArrIndex,
        entityDefinition,
      }),
      {}
    );
  } else if (
    nothingWasResolved &&
    !controlIsInTable &&
    !resolvedDataExpression.includes('ss.currentRecordId')
  ) {
    dataContext = _.get(data, `${ENTITY_DATA_PREFIX}${entityType}`, {});
  } else {
    dataContext = data;
  }

  const ssCtx = { ...ssContext, ...ssFunctions, data: dataContext, isHyperlinkUrl };

  if (isExpression(resolvedDataExpression)) {
    return evalSSEexpression(resolvedDataExpression, ssCtx);
  }

  return evaluate(resolvedDataExpression, ssCtx);
};

// TODO: deprecated
export const isExpression = (str) => {
  return _.isString(str) && !_.isNil(str.match(/^ss\.|data\.|\{|\||\}/g));
};

/**
 * Input string sample
 * ss.stringFormat('{0} ({1})',ss.getFormTranslation('grdCAPAAttachment_Title'), ss.rowCount({|CAPA|V_SS_CAPA|}, 'V_SS_CAPA-V_BAH_BASE_ATTACHMENT_GEN', 'grdCAPAAttachment'))
 * ({|Finalize Request Required?|V_SS_CHGM_PLN-V_SS_CHGM_PLN_POLICY.CP_FINALIZE_REQ|} &amp;amp;&amp;amp; {|Phase|V_SS_CHGM_PLN.PHASE|} !='Change Plan Final Planning' ? &amp;quot;Finalize Change Plan&amp;quot; : &amp;quot;&amp;quot;)
 * @param ssStr
 * @returns {string|*}
 */
export const preprocessSSEvaluation = (ssStr) => {
  // TODO: is there more replacements? e.g. '&amp;gt;' => '>'
  const replacementMap = {
    '\t': ' ',
    '\r': ' ',
    '\n': ' ',
    '&amp;quot;': "'",
    '&quot;': "'",
    '&amp;amp;': '&',
    '&amp;&amp;': '&&',
  };

  return ssStr.replace(/\t|\r|\n|&amp;quot;|&amp;&amp;|&amp;amp;|&quot;/g, (x) =>
    replacementMap[x] ? replacementMap[x] : x
  );
};

/**
 *  if pattern is like data.{DATA_FIELD} lookup based on rule context (rule.DataMember)
 *
 *  data.YES_NEXT_DECISION
 *  ->
 *  _.get(data, 'entityDataStore.entityData.V_SE_ISSUE.V_SE_ISSUE-V_SE_GENERIC_DECISION_TREE[0].YES_NEXT_DECISION')
 * @param ssStr
 * @param ssContext
 * @returns {string|*}
 */
export const preprocessRuleContext = (ssStr, ssContext) => {
  const { entityType, contextDataMember, gridArrIndex, entityDefinition } = ssContext;

  if (ssStr.startsWith('data.') && contextDataMember) {
    const xPath = getDataMemberPath({
      entityType,
      dataMember: contextDataMember,
      gridArrIndex,
      dataField: ssStr.split('.')[1],
      entityDefinition,
    });

    return `_.get(data, '${xPath}')`;
  }

  if (ssStr.startsWith('data.') && _.isNil(contextDataMember)) {
    console.log('contextDataMember is expected but missed');
  }

  return ssStr;
};

// EUROPA-656
export const patchClientManagerLookup = (ssStr) => {
  return ssStr.indexOf('pageClientManager._dataStore.entityData') > -1
    ? ssStr.split('pageClientManager._dataStore.entityData').join('data.entityDataStore.entityData')
    : ssStr;
};

// don't replace it with regexp - we may need resolve data inside later
export const resolveData = (data, entityType, gridArrIndex, entityDefinition, str) => {
  let idx1 = 0;
  let idx2 = 0;
  let outStr = str;

  try {
    do {
      idx1 = outStr.indexOf('{|');
      idx2 = outStr.indexOf('|}', idx1);

      if (idx1 >= 0 && idx2 > 0) {
        const match = outStr.substring(idx1, idx2 + 1);
        let dataMember;
        let dataField;
        const dataRef = match.split('|')[2]; // dataMember or dataMember.dataField

        if (dataRef.includes('.')) {
          [dataMember, dataField] = dataRef.split('.');
        } else {
          dataMember = dataRef;
        }

        if (dataMember === undefined) {
          console.log(`resolveData() dataMember is undefined for dataRef ${dataRef}`);
        }

        const dataMemberGridIndex = getValueIndex(gridArrIndex, dataMember, entityDefinition);
        const refPath = `_.get(data, '${getDataMemberPath({
          entityType,
          dataMember,
          gridArrIndex: dataMemberGridIndex,
          dataField,
          entityDefinition,
        })}')`; // refPath will be resolved later during evaluation
        outStr = outStr.substring(0, idx1) + refPath + outStr.substring(idx2 + 2);
      }
    } while (idx1 >= 0 && idx2 > 0);
  } catch (err) {
    console.log(`Evaluation error: ${err}`);
  }

  return outStr;
};

// keep 'data', 'ssContext' and 'translations' in scope
export const evaluate = (expression, ssContext) => {
  const { data, translations, isHyperlinkUrl } = ssContext;
  const ss = _ss; // trick to keep ss in scope of expression evaluation (browser and test cases)
  // trick to keep lodash in scope of expression evaluation (for test cases)
  // _. -> lodash.
  const lodash = _;

  if (_.isString(expression)) {
    expression = expression.replace(/_\./g, 'lodash.');

    //specific case for hyperlink url expression only, to decode its value at next evaluation step
    if (expression.startsWith('ss.stringFormat') && isHyperlinkUrl) {
      //remove closing ")" bracket from expression body
      const mainExpressionPart = expression.substring(0, expression.length - 1);

      //insert {isHyperlinkUrl: true} object as last argument inside the expression body
      //to let ss function know that the evaluation will happen for hyperlink url
      expression = `${mainExpressionPart},${JSON.stringify({ isHyperlinkUrl: true })})`;
    }
  }

  try {
    const result = eval(`${expression}`);
    return result;
  } catch (error) {
    console.log(`Evaluation error ${error} for expression ${expression}`);
    return '_eval_error_'; // TODO: return '_eval_error_' string - quite handling for custom JS block (EUROPA-656) (e.g. heat map)
  }
};

// keep getConditionValue(). It is used form inside eval()
// is used for Rules and for Filters
// keep datasourceRow param
export const evaluateConditions = ({ conditions, ssContext, datasourceRow }) => {
  if (_.isNil(conditions) || conditions.length === 0) {
    return true;
  }

  if (_.isBoolean(conditions)) {
    return conditions;
  }

  let conditionsEvalStr = ' ';

  toArray(conditions).forEach((condition, index, array) => {
    const left = `getConditionValue(conditions[${index}].LeftType, conditions[${index}].LeftValue, ssContext, datasourceRow)`;
    const right = `getConditionValue(conditions[${index}].RightType, conditions[${index}].RightValue, ssContext, datasourceRow)`;

    if (isTrue(condition.OpenGroup)) {
      conditionsEvalStr += ' ( ';
    }

    const operator = condition.Operator || condition.SqlOperator;

    switch (operator) {
      case 'EQ':
        conditionsEvalStr += `eqOperator(${left}, ${right})`;
        break;
      case 'NEQ':
        conditionsEvalStr += `neqOperator(${left}, ${right})`;
        break;
      case 'LT':
        conditionsEvalStr += `ltOperator(${left}, ${right})`;
        break;
      case 'GT':
        conditionsEvalStr += `gtOperator(${left}, ${right})`;
        break;
      case 'LTEQ':
        conditionsEvalStr += `lteqOperator(${left}, ${right})`;
        break;
      case 'GTEQ':
        conditionsEvalStr += `gteqOperator(${left}, ${right})`;
        break;

      case 'ISNULL': // validate left side only
        conditionsEvalStr += `isnullOperator(${left})`;
        break;
      case 'ISNOTNULL': // validate left side only
        conditionsEvalStr += `isNotNullOperator(${left})`;
        break;
      case 'SW':
      case 'EW':
      case 'CT':
        conditionsEvalStr += `complexOperator('${operator}', ${left}, ${right})`;
        break;

      default:
        conditionsEvalStr += `defaultOperator('${operator}', ${left}, ${right})`;
    }

    if (isTrue(condition.CloseGroup)) {
      conditionsEvalStr += ' ) ';
    }

    // if the not last condition
    if (index < array.length - 1) {
      switch (condition.RelationalOperator) {
        case 'OR':
          conditionsEvalStr += ' || ';
          break;
        case 'AND':
        default:
          conditionsEvalStr += ' && ';
      }
    }
  }); // end of loop

  // variables are used inside evaluations
  const { data, entityType, gridArrIndex, translations } = ssContext;
  let ruleConditionsMatch = true;

  try {
    eval(
      `if ( ${conditionsEvalStr} ) { ruleConditionsMatch = true } else { ruleConditionsMatch = false }`
    );
  } catch (error) {
    ruleConditionsMatch = false;
    console.log(`Condition evaluation failed with error ${error}`);
    console.log(`conditionsEvalStr: ${conditionsEvalStr}`);
  }

  return ruleConditionsMatch;
};

export const getValueIndex = (gridArrIndex, dataMember, entityDefinition) => {
  let valueIndex = gridArrIndex;

  if (dataMember.includes('-V')) {
    // if sub entity -> check relationship key in entityDefinition
    if (entityDefinition) {
      const dataMemberRelationShipKey = getRelationShipKey(entityDefinition, dataMember);
      const { parentDataRelationshipKey, dataMemberArray } = getParentRelationshipKey({
        entityDefinition,
        dataMember,
      });

      if (
        (dataMemberArray.length === 1 && dataMemberRelationShipKey === '1to1') ||
        (dataMemberRelationShipKey === '1to1' && parentDataRelationshipKey === '1to1')
      ) {
        valueIndex = 0;
      } else {
        valueIndex = gridArrIndex;
      }
    }
  }

  return valueIndex;
};

export const isParentDataMember = (parentDataMember = '', childDataMember = '') =>
  parentDataMember.length > 0 && childDataMember.startsWith(parentDataMember);

export const sliceGridArrIndexForDataMember = (gridArrIndex, dataMember) => {
  if (!Array.isArray(gridArrIndex)) {
    return gridArrIndex;
  }

  const { length } = dataMember.split('-').slice(1);

  return gridArrIndex.slice(0, length);
};

export const getConditionValue = (type, value, ssContext, datasourceRow) => {
  const {
    data,
    entityType,
    gridArrIndex,
    useRowData,
    contextDataMember,
    translations,
    entityDefinition,
    conditionDataMember,
  } = ssContext;

  switch (type) {
    case 'column': {
      if (value == '') {
        return value; // sometimes it's empty (e.g. for ISNULL operation)
      }

      const dataMember = value.split('.')[0]; // V_SS_CAPA-V_SS_CAPA_ROOT_CAUSE
      const dataField = value.split('.')[1];
      const searchInRowData = conditionDataMember === dataMember && datasourceRow;
      const rowValue = datasourceRow && datasourceRow[dataField];

      if (dataMember === 'data' || (useRowData && (!_.isNil(rowValue) || searchInRowData))) {
        // Condition !_.isNil(rowValue) breaks scenario when the value exists in a table and right now it's undefined,
        // we still need to consider such value as valid.
        // Potentially we can replace this check by checking if dataMember from the condition is the same as curent dataMember (we will need
        // to add conditionDataMember to some functions, right now is't used only inside rowCountWithFilterImpl)

        // dataMember === 'data' handles reference for current row 'data.' e.g. data.ACTION_PLAN_LEVEL (EUROPA-1824)
        return rowValue;
      }

      if (_.isNil(entityType)) {
        throw new Error("getConditionValue() 'entityType' is required param");
      }

      const dataMemberGridIndex = isParentDataMember(dataMember, contextDataMember)
        ? sliceGridArrIndexForDataMember(gridArrIndex, dataMember)
        : getValueIndex(gridArrIndex, dataMember, entityDefinition);

      const xPath = getDataMemberPath({
        entityType,
        dataMember,
        gridArrIndex: dataMemberGridIndex,
        dataField,
        entityDefinition,
      });

      const conditionValue = _.get(data, xPath);
      return conditionValue;
    }

    case 'text':
      return value;

    case 'number':
      return !_.isNil(value) ? Number(value) : undefined;

    case 'date':
      return value;

    case 'boolean':
      return value === 'true';

    case 'datasource': {
      const dsValue = _.isNil(datasourceRow) ? undefined : datasourceRow[`${value}`];
      return typeof dsValue === 'string' ? dsValue.trim() : dsValue;
    }

    case 'formula': {
      const formulaResult = evalSSEexpression(value, ssContext);
      return formulaResult;
    }

    default:
      console.log(`${type} - type is not implemented`);
      return undefined;
  }
};

export const eqOperator = (leftValue, rightValue) => {
  // sometimes datasource data pass boolean as string
  // (with no way to validate data types vs entity/entity-definition case)
  if (_.isBoolean(leftValue) && _.isString(rightValue)) {
    return leftValue.toString() === rightValue;
  }

  if (_.isString(leftValue) && _.isBoolean(rightValue)) {
    return leftValue === rightValue.toString();
  }

  if (_.isDate(leftValue) && _.isDate(rightValue)) {
    return leftValue.getTime() === rightValue.getTime();
  }

  // case insensitive comparison for Strings (CAPA-Internal-Default match CAPA-Internal-default)
  if (_.isString(leftValue) && _.isString(rightValue)) {
    return leftValue.toLowerCase() == rightValue.toLowerCase();
  }

  // avoid strict equation '===', so string and numbers can be compared ('1' == 1) EUROPA-1757
  return leftValue == rightValue;
};

export const neqOperator = (leftValue, rightValue) => {
  // sometimes datasource data pass boolean as string
  // (with no way to validate data types vs entity/entity-definition case)
  if (_.isBoolean(leftValue) && _.isString(rightValue)) {
    return leftValue.toString() !== rightValue;
  }

  if (_.isString(leftValue) && _.isBoolean(rightValue)) {
    return leftValue !== rightValue.toString();
  }

  // case insensitive comparison for Strings (CAPA-Internal-Default match CAPA-Internal-default)
  if (_.isString(leftValue) && _.isString(rightValue)) {
    return leftValue.toLowerCase() != rightValue.toLowerCase();
  }

  // avoid strict equation '!==', so string and numbers can be compared ('1' == 1) EUROPA-1757
  return leftValue != rightValue;
};

export const isNumberString = (str) => {
  return _.isString(str) && str.match(/^\d+$/);
};

export const ltOperator = (leftValue, rightValue) => {
  const left = isNumberString(leftValue) ? parseInt(leftValue, 10) : leftValue;
  const right = isNumberString(rightValue) ? parseInt(rightValue, 10) : rightValue;

  return typeof left === typeof right ? left < right : false;
};

export const gtOperator = (leftValue, rightValue) => {
  const left = isNumberString(leftValue) ? parseInt(leftValue, 10) : leftValue;
  const right = isNumberString(rightValue) ? parseInt(rightValue, 10) : rightValue;

  return typeof left === typeof right ? left > right : false;
};

export const lteqOperator = (leftValue, rightValue) => {
  const left = isNumberString(leftValue) ? parseInt(leftValue, 10) : leftValue;
  const right = isNumberString(rightValue) ? parseInt(rightValue, 10) : rightValue;

  return typeof left === typeof right ? left <= right : false;
};

export const gteqOperator = (leftValue, rightValue) => {
  const left = isNumberString(leftValue) ? parseInt(leftValue, 10) : leftValue;
  const right = isNumberString(rightValue) ? parseInt(rightValue, 10) : rightValue;

  return typeof left === typeof right ? left >= right : false;
};

export const isnullOperator = (leftValue) => {
  // handle empty string as Null (e.g. CAPA|Initial Risk Assessment|Document Number issue)
  if (_.isString(leftValue) && leftValue.length === 0) {
    return true;
  }

  return _.isNil(leftValue);
};

export const isNotNullOperator = (leftValue) => {
  // handle empty string as Null (CAPA | Investigation page | Initial Risk Assessment / Serverity Rating is not null)
  if (_.isString(leftValue) && leftValue.length === 0) {
    return false;
  }

  return !_.isNil(leftValue);
};

// operator evaluation implementation for 'EW, SW, CT'
// similar to clientManager.js.cm_complexOperator(...)
export const complexOperator = (operator, leftValue, rightValue) => {
  // do not eval if either side is null
  if (leftValue === null || rightValue === null) {
    return false;
  }

  switch (operator) {
    case 'SW':
      return leftValue.startsWith(rightValue);
    case 'EW':
      return leftValue.endsWith(rightValue);
    case 'CT':
      return leftValue.toLowerCase().indexOf(rightValue.toLowerCase()) !== -1;
    default:
      throw Error(`Operator ${operator} is not implemented `);
  }
};

export const defaultOperator = (operator, leftValue, rightValue) => {
  console.log(`Operator ${operator} is not implemented `);
  return false;
};
